export default __webpack_public_path__ + "static/media/rangingpot.369e1ac1.PNG";